module.exports = __webpack_public_path__ + "fallback.png";


//////////////////
// WEBPACK FOOTER
// ../node_modules/file-loader/dist/cjs.js?name=fallback.png!./assets/images/fallback.png
// module id = tzb/
// module chunks = 0